export enum ImageFormat {
  PNG = "png",
  JPG = "jpg",
  WEBP = "webp",
}

export type PixiImageFormat = "png" | "jpg" | "webp";